const imageSizes = require('./constants/image.json');

const RESPONSIVE_IMAGE_CONFIG = process.env.DISABLE_RESPONSIVE_IMAGES
  ? null
  : {
      sizes: {
        socialMeta: {
          single: {
            r: {
              width: 1280
            }
          }
        },
        'card:portrait:grid--one': {
          widths: imageSizes['16:9'],
          sizes: '100vw'
        },
        'card:portrait:grid--one:related-videos': {
          widths: imageSizes.landscape,
          sizes: '(max-width: 768px) 100vw, 33vw'
        },
        'card:portrait:grid--one:sidebar-card': {
          widths: imageSizes.standardWidths,
          sizes: '(max-width: 768px) 100vw, 20vw'
        },
        'card:portrait:grid--one:carousel': {
          widths: imageSizes.standardWidths,
          sizes: '(max-width: 768px) 20vw, 50vw'
        },
        'card:portrait:grid--two': {
          widths: imageSizes.standardWidths,
          sizes: '(max-width: 768px) 100vw, 50vw'
        },
        'card:portrait:grid--three': {
          widths: imageSizes.landscape,
          sizes: '(max-width: 768px) 100vw, 33vw'
        },
        'card:portrait:grid--three:review card--animated-image': {
          widths: imageSizes.standardWidths,
          sizes: '(max-width: 768px) 100vw, 50vw'
        },
        'card:portrait:grid--four': {
          widths: imageSizes.standardWidths,
          sizes: '(max-width: 768px) 100vw, (max-width: 1024px) 50vw, 25vw'
        },
        'card:portrait:grid--four:shadow-border': {
          widths: imageSizes.landscape,
          sizes: '(max-width: 768px) 100vw, (max-width: 1024px) 50vw, 25vw'
        },
        'card:portrait:grid--four:speakers': {
          widths: {
            '320w': {
              r: {
                width: '320',
                height: '320'
              }
            },
            '420w': {
              r: {
                width: '420',
                height: '420'
              }
            },
            '520w': {
              r: {
                width: '520',
                height: '520'
              }
            }
          },
          sizes: '(max-width: 768px) 100vw, (max-width: 1024px) 50vw, 10vw'
        },
        // speaker listings using 'Listing - Speakers by type' template
        'card:portrait:grid--four:speakers card--scale-image': {
          widths: {
            '320w': {
              r: {
                width: '320',
                height: '320'
              }
            },
            '420w': {
              r: {
                width: '420',
                height: '420'
              }
            },
            '520w': {
              r: {
                width: '520',
                height: '520'
              }
            }
          },
          sizes: '(max-width: 768px) 100vw, (max-width: 1024px) 50vw, 10vw'
        },
        // speaker reviews on 'Feature landing page' template
        'card:portrait:grid--three:review card--animated-image card--hover': {
          widths: {
            '320w': {
              r: {
                width: '320',
                height: '320'
              }
            },
            '420w': {
              r: {
                width: '420',
                height: '420'
              }
            },
            '520w': {
              r: {
                width: '520',
                height: '520'
              }
            }
          },
          sizes: '(max-width: 768px) 100vw, (max-width: 1024px) 50vw, 10vw'
        },
        'card:landscape:grid--two': {
          widths: imageSizes.standardWidths,
          sizes: '(max-width: 768px) 40vw, 10vw'
        },
        'card:landscape:grid--one': {
          widths: imageSizes.standardWidths,
          sizes: '40vw'
        },
        'card:landscape:grid--two:testimonials': {
          widths: {
            '200w': {
              r: {
                width: '200',
                height: '200'
              }
            }
          },
          sizes: '20vw'
        },
        card: {
          widths: imageSizes.standardWidths,
          sizes: '100vw'
        },
        globalLightbox: {
          widths: imageSizes.standardWidths,
          sizes: '100vw'
        },
        'image:responsive': {
          widths: imageSizes.standardWidths,
          sizes: '100vw'
        },
        'image:responsive min-aspect': {
          widths: imageSizes.standardWidths,
          sizes: '100vw'
        },
        'image:content-image': {
          widths: imageSizes.standardWidths,
          sizes: '(max-width: 660px) 100vw, 768px'
        },
        'image:speaker-profile-image': {
          widths: imageSizes.standardWidths,
          sizes: '(max-width: 768px) 100vw, 20vw'
        },
        // related from the blog on 'Feature landing page' template
        'card:portrait:grid--four:hover card--darken-image card--limit-details__3lines': {
          widths: imageSizes.landscape,
          sizes: '(max-width: 768px) 100vw, (max-width: 1024px) 50vw, 25vw'
        },
        // speaker one per row on 'Blog with speakers' template
        'card:portrait:grid--one:speakers card--scale-image': {
          widths: {
            '320w': {
              r: {
                width: '320',
                height: '320'
              }
            },
            '420w': {
              r: {
                width: '420',
                height: '420'
              }
            },
            '520w': {
              r: {
                width: '520',
                height: '520'
              }
            }
          },
          sizes: '(max-width: 768px) 100vw, (max-width: 1024px) 50vw, 10vw'
        },
        // --------------------
        'image:image--speaker': {
          widths: {
            '320w': {
              r: {
                width: '320',
                height: '320'
              }
            }
          },
          sizes: '100vw'
        },
        carousel: {
          widths: {
            // 525w is wrong but will trigger srcset correctly
            '525w': {
              r: {
                height: 350
              }
            }
          },
          sizes: '100vw'
        },
        'card:portrait:grid--one:two-line-cards': {
          widths: {
            // 525w is wrong but will trigger srcset correctly
            '525w': {
              r: {
                height: 350
              }
            }
          },
          sizes: '100vw'
        }
      }
    };

export { RESPONSIVE_IMAGE_CONFIG };
